import React from 'react';
import '../css/components/Footer.css';

export default class Footer extends React.Component {
  render() {
    return (
      <footer className="footer">
        <div className="container-left">
            <p>Flávio Bianchetti</p>
            <p>Desenvolvedor Web</p>
            <p>- 2022 -</p>
        </div>
        <hr />
        <div className="container-right">
          <div>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.linkedin.com/in/flaviobianchetti/"
            >
              <img
                src="https://img.icons8.com/ios-glyphs/30/D6D6D6/linkedin.png"
                alt="Flávio Bianchetti's LinkedIn"
              />
              linkedin.com/in/flaviobianchetti
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://github.com/flavio-bianchetti"
            >
              <img
                src="https://img.icons8.com/ios-glyphs/30/D6D6D6/github.png"
                alt="Flávio Bianchetti's LinkedIn"
              />
              github.com/flavio-bianchetti
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.instagram.com/flavio.bianchetti/"
            >
              <img
                src="https://img.icons8.com/ios/30/D6D6D6/instagram-new.png"
                alt="Flávio Bianchetti's LinkedIn"
              />
              instagram.com/flavio.bianchetti
            </a>
          </div>
        </div>
      </footer>
    );
  }
}
